import React, { useState } from 'react'
import invariant from 'tiny-invariant'

import ConfirmedBookingDetails from '@/components/integration/nylas/scheduler/components/ConfirmedBookingDetails'
import Scheduler from '@/components/integration/nylas/scheduler/Scheduler'
import {
  BookedMeetingDetails,
  MeetingDetails,
  SchedulerOwningEntityType,
  SchedulerParticipant,
} from '@/components/integration/nylas/scheduler/types'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import LoadingOverlay from '@/components/widgets/LoadingOverlay'

interface Props {
  primaryParticipant: SchedulerParticipant
  onComplete: (
    bookingDetails: MeetingDetails,
  ) => Promise<BookedMeetingDetails | undefined>
  onHide: () => void
  isProcessing: boolean
  toCompanyName: string
  toCompanyId: number
}

const SchedulerModal: React.FC<Props> = ({
  primaryParticipant,
  onHide,
  onComplete,
  isProcessing,
  toCompanyName,
  toCompanyId,
}) => {
  const [bookingDetails, setBookingDetails] =
    useState<BookedMeetingDetails | null>(null)

  return (
    <Dialog open onHide={onHide}>
      <DialogContent size="xl">
        <DialogHeader>
          <DialogTitle>Schedule a meeting</DialogTitle>
        </DialogHeader>

        <LoadingOverlay isActive={isProcessing} opaque>
          <DialogBody>
            <div className="flex flex-col items-center">
              {bookingDetails ? (
                <ConfirmedBookingDetails
                  bookingDetails={bookingDetails}
                  toCompanyName={toCompanyName}
                />
              ) : (
                <Scheduler
                  hideChrome
                  owningEntityId={toCompanyId}
                  owningEntityType={SchedulerOwningEntityType.Company}
                  primaryParticipant={primaryParticipant}
                  onSchedulerSubmit={async (meetingDetails: MeetingDetails) => {
                    const bookedMeetingDetails =
                      await onComplete(meetingDetails)
                    invariant(!!bookedMeetingDetails)
                    setBookingDetails(bookedMeetingDetails)
                  }}
                />
              )}
            </div>
          </DialogBody>
        </LoadingOverlay>
      </DialogContent>
    </Dialog>
  )
}

export default SchedulerModal
